/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { EventCard } from '../../../cards';
import UpgradeToUtrCollegeButton from '../../../Upgrade/UpgradeToUtrCollege/upgradeToUtrCollegeButton';
import CreateEventButton from '../CreateEventButton';
import SchedulePlayButton from '../SchedulePlayButton';
import UpgradeToPerformanceHsButton from '../../../Upgrade/UpgradeToPerformanceHs/UpgradeToPerformanceHsButton';
import { EventScheduleTypes } from '../../../../utils/eventConstants';

import dummyEvents from './dummyEvents';

import styles from '../../../../pages/ClubProfiles/club.scss';
import { showCompleteRegistration } from '../../../../utils/events';

const TMSEventsList = (props) => {
    const {
        eventsList,
        type,
        showAll,
        auth,
        coreUI,
        isAdminOrOwner,
        canRunEvents,
        isOwner,
        isPersonalClub,
        isTournamentClub,
        tmsEventsFetchState,
        clubIsFreeCollege,
        onUpgradeToCollegeClick,
        onShowAllClick,
        onCreateEventClick,
        isClubMember,
        clubStatus,
        clubIsFreeSchool,
        onUpgradePerformanceHsClick,
        isProfilePage,
    } = props;

    const { INPROGRESS, UPCOMING, RECENT } = EventScheduleTypes;
    const getEventsListData = () => {
        const UpcomingEventIds = new Set();
        const InprogressEventIds = new Set();
        const PastEventIds = new Set();

        if (type === UPCOMING) {
            return eventsList?.filter(event => {
                if (event.momentStartDate.isAfter(moment())) {
                    if (!UpcomingEventIds.has(event.id)) {
                        // If the event ID is not in the Set, add it and include this event
                        UpcomingEventIds.add(event.id);
                        return true;
                    }
                }
                return false;
            });
        }
        if (type === INPROGRESS) {
            return eventsList.filter(event => {
                if (event.momentStartDate.isSameOrBefore(moment()) && event.momentEndDate.isAfter(moment()) && event.published) {
                    // Define a Set to keep track of unique event IDs
                    if (!InprogressEventIds.has(event.id)) {
                        // If the event ID is not in the Set, add it and include this event
                        InprogressEventIds.add(event.id);
                        return true;
                    }
                }
                return false;
            });
        }
        if (type === RECENT) {
            return eventsList.filter(event => {
                // Define a Set to keep track of unique event IDs
                if (!PastEventIds.has(event.id)) {
                    // If the event ID is not in the Set, add it and include this event
                    PastEventIds.add(event.id);
                    return true;
                }

                return false;
            });
        }
        return eventsList;
    };
    const eventListData = getEventsListData();

    const NoInProgressEvents = type === INPROGRESS && eventListData.length === 0;

    if (eventListData && eventListData.length > 0) {
        return (
            <div>
                <div className="row">
                    {eventListData.map((event, i) => {
                        // console.log('EventList event', event);
                        if (i <= 3 || showAll) {
                            return (
                                <div
                                    className="col-12"
                                    key={`${type}-event-${event.id}`}
                                >
                                    <EventCard
                                        coreUI={coreUI}
                                        event={event}
                                        auth={auth}
                                        force={{ hideOrganizer: true, cardView: true }}
                                        isAdminOrOwner={isAdminOrOwner}
                                        isClubMember={isClubMember}
                                        showCompleteRegistration={showCompleteRegistration(event, auth.user?.claimedPlayer?.playerId)}
                                        isProfilePage={isProfilePage}
                                    />
                                </div>
                            );
                        }
                        return null;
                    })}
                </div>
                {!showAll && (
                    <div
                        className={`${styles.seeMore} ${eventListData.length > 4 ? 'd-block' : 'd-none'}`}
                        onClick={(ev) => {
                            onShowAllClick(ev);
                        }}
                    >
                        See All Events
                    </div>
                )}
            </div>
        );
    }
    if (tmsEventsFetchState.loading) {
        return (
            <p>Loading events...</p>
        );
    }
    if ((isAdminOrOwner && (canRunEvents || clubIsFreeCollege)) || (clubIsFreeSchool)) {
        return (
            <div className={`${styles.placeHolderGrid}`}>
                <div className="row">
                    {dummyEvents.map(event => (
                        <div
                            className="col-12"
                            key={`${type}-event-${event.id}`}
                        >
                            <EventCard
                                event={event}
                                auth={auth}
                                coreUI={coreUI}
                                force={{ hideOrganizer: true }}
                                isAdminOrOwner={isAdminOrOwner}
                                isClubMember={isClubMember}
                                isProfilePage={isProfilePage}
                            />
                        </div>
                    ))}
                </div>
                <div className={`${styles.overlay}`} />
                <div className={`${styles.actionWrapper}`}>
                    {canRunEvents && (
                        (isAdminOrOwner && isPersonalClub) ? (
                            <SchedulePlayButton
                                onClick={onCreateEventClick}
                            />
                        )
                            : (isOwner && clubIsFreeSchool) ? (
                                <UpgradeToPerformanceHsButton
                                    onClick={onUpgradePerformanceHsClick}
                                    user={auth.user}
                                />
                            )
                                : (
                                    NoInProgressEvents ? 'No events are in progress' : <CreateEventButton onClick={onCreateEventClick} isTournamentClub={isTournamentClub} />
                                )
                    )}
                    {!canRunEvents && isOwner && clubIsFreeCollege && (
                        <UpgradeToUtrCollegeButton
                            onClick={onUpgradeToCollegeClick}
                            user={auth.user}
                            clubStatus={clubStatus}
                        />
                    )}
                </div>
            </div>
        );
    }
    return (
        <div className="row mt64">
            <div className="col-12">
                <p className="text-center">No events have been added yet <br />
                    Check back for events
                </p>
            </div>
        </div>
    );
};

TMSEventsList.propTypes = {
    eventsList: PropTypes.arrayOf(PropTypes.shape),
    type: PropTypes.string,
    showAll: PropTypes.bool,
    auth: PropTypes.instanceOf(Object).isRequired,
    coreUI: PropTypes.instanceOf(Object).isRequired,
    eventsTabState: PropTypes.shape({
        eventsType: PropTypes.string,
    }),
    isAdminOrOwner: PropTypes.bool,
    canRunEvents: PropTypes.bool,
    isOwner: PropTypes.bool,
    isPersonalClub: PropTypes.bool,
    isTournamentClub: PropTypes.bool,
    tmsEventsFetchState: PropTypes.string,
    clubIsFreeCollege: PropTypes.bool,
    onUpgradeToCollegeClick: PropTypes.func,
    onShowAllClick: PropTypes.func,
    onCreateEventClick: PropTypes.func,
    isClubMember: PropTypes.bool,
    clubIsFreeSchool: PropTypes.bool,
    onUpgradePerformanceHsClick: PropTypes.func,
    isProfilePage: PropTypes.bool,
};
export default TMSEventsList;
